import axios from 'axios';

export default class Modal {

    constructor() {
        
    }

    fetch(url) {
        axios.get('./'+url).then((response) => {
            if(response.data.content){
                let content = response.data.content,
                    currentModal = document.getElementById("uzayModal");
        
                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(response.data);
                    });
                }
        
                if(currentModal){
                    currentModal.querySelector(".modal-body").innerHTML = response.data.content;
                    window.App.common.init(currentModal);
                    return;
                }
        
                this.open(response.data.content);
            }
        });
    }
    
    open(content) {
        const modal = this.createModal();
        modal.querySelector(".modal-body").innerHTML = content;
        modal.querySelectorAll(".modal-close").forEach(el => {
            el.addEventListener("click", () => {
                this.close();
            });
        }) 
        document.body.classList.add('bodyoverlay');
        document.body.append(modal);
        
        window.App.common.init(modal);
    }
    
    createModal()
    {
        var template = document.createElement('template');
        template.innerHTML = '<div class="modal" id="uzayModal" tabindex="-1"><div class="modal-dialog"><div class="modal-content"><div class="modal-body"></div><button type="button" class="btn-close modal-close"><i class="icon icon-cross"></i></button></div></div></div>';
        return template.content.firstChild;
    }

    close() {
        const modal = document.getElementById("uzayModal");
        if(modal){
            modal.remove();
            if(!document.getElementById('sidebar').classList.contains('open')) {
                document.body.classList.remove('bodyoverlay');
            }
        }
    }
}